// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zoom-slider {
    padding-top: 20px;
    padding-bottom: 20px;
}

.save-profile-image-button {
    width: 70%;
    background-color: #001E60;
    color: white;
    padding: 8px 30px;
    margin-top: 10px;
    margin-bottom: 30px;
    border: none;
    border-radius: 10px;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 2px;
    transition: 300ms ease;
    text-align: center; 
}

.save-profile-image-button:hover
{
    background-color: #ecaa1e;
    color:#001E60;
}

.picture-upload {
    padding: 20px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}


.profile-page
{
    overflow-x: hidden;
}

.file-upload-button {
    padding: 8px 20px;
    margin: 10px;
    border: none;
    outline: none;
    background-color: #3498db;
    color: #fff;
    border-radius: 10px;
    cursor: pointer;
    transition: 200ms ease;
  }
  
  .file-upload-button:hover {
    background-color: #2980b9;
  }
  
  .file-upload-button:active {
    background-color: #1c638d;
  }
  
  .profile-picture-editor {
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

.profile-container
{
    padding: 40px 20px 164px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.profile-picture
{
    width : 225px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color : white;
    position: relative;
    margin-right: 80px;
}

.profile-img
{
    width : 100%;
    margin-bottom : 20px;
    border-radius: 50%;
}

.profile-image-edit-button {
    position: absolute;
    bottom: 120px;
    right: 20px;
    background-color: #fff; 
    border: 1px solid #ccc; 
    border-radius: 50%; 

    cursor: pointer;
    font-size: 28px;
    color: #001E60;

    width: 38px;
    height: 38px; 
    display: flex;
    justify-content: center; 
    align-items: center; 
    scale: 1.1;
}

.profile-name-display
{
    margin-bottom : 5px;
    white-space: nowrap;
}

.profile-email-display
{
    margin-bottom : 8px;
}

.profile-inputs-section
{
    width: 100%;
    display: flex;
    align-items: center;
}

.profile-change-container
{
    display: flex;
    width: 89%;
    justify-content: flex-end;
    align-items: center;
    margin-top: 35px;
}

.profile-change
{
    font-size: 15px;
    background-color:#001E60;
    padding: 6px 16px 6px 16px;
    margin: 0px 10px;
    font-family: "poppins";
    color: white;
    border-radius: 15px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    border: none;
    transition: all 0.3s ease-in-out;
}

.profile-change:hover
{
    background-color :#00468D;
}

.profile-input-container
{
    width : 60%;
    display: flex;
    justify-content: center;
    flex-wrap : wrap;
    justify-content: flex-end;
}

.profile-input-name
{
    width : 100%;
    display: flex;
    color: white;
    margin-bottom : 40px;
    align-items: center;
    justify-content: flex-start;
}

.profile-input-email
{
    width : 100%;
    display: flex;
    color: white;
    margin-bottom : 40px;
    align-items: center;
    justify-content: flex-end;
}

.profile-name-title
{
    margin-right : 10px;
    font-weight: 500;
    white-space: nowrap;
}

.profile-email-title
{
    margin-right : 10px;
    font-weight: 500;
}

.profile-name
{
    width : 70%;
    padding : 8px 10px;
    color : white;
    border-radius : 10px;
    background-color :#00468D;
}

.profile-email
{
    width: 70%;
    padding : 8px 10px;
    color : white;
    border-radius : 10px;
    background-color :#00468D;
}

.profile-description-container
{
    width : 100%;
    display: flex;
    flex-direction: column;
    color: white;
}

.profile-description-title
{
    margin-bottom : 10px;
    font-weight: 500;
}

.profile-description
{
    width : 100%;
    padding : 12px 15px;
    color : white;
    border-radius : 10px;
    background-color :#00468D;
}

.profile-analytics
{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-around;
    color : white;
    margin-top : 70px;
}

.profile-section-container
{
    text-align: center;
    margin: 0px 20px;
}

.profile-section-title
{
    font-weight: 500;
    font-size : 18px;
    margin-bottom : 5px;
}

.profile-section-input
{
    font-size : 18px;
}

.profile-save-button
{
    width: 80%;
    background-color: #001E60;
    color: white;
    padding: 14px 20px;
    margin-top: 100px;
    border: none;
    border-radius: 4px;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 2px;
    transition: 500ms ease;
    text-align: center;
}

.profile-save-button:hover
{
    background-color : #ecaa1e;
    color: #001E60;
}

.password-popup-container
{
    position: fixed;
    top: -50px;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fade-in 0.2s ease-in-out;
}

.password-popup-content
{
    background-color: #0096C9;
    padding: 30px;
    border-radius: 10px;
    z-index: 1;
    width: 50%;
    padding-bottom: 35px;
    margin-top : 60px;
}

.pop-up-old-password
{
    margin-top : 30px;
    padding : 8px 12px;
    width: 300px;
}

.pop-up-enter
{
    font-size : 20px;
    background-color:#001e60;
    padding: 6px 16px;
    font-family: "poppins";
    color: white;
    font-weight: bold;
    border-radius: 15px;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    margin-bottom: 20px;
    width : 100%;
}

.pop-up-enter:hover
{
    color: white;
    background-color: #00468D;
}

.pop-up-cancel
{
    font-size : 20px;
    background-color: #ecaa1e;
    padding: 6px 16px;
    font-family: "poppins";
    color: #001E60;
    font-weight: bold;
    border-radius: 15px;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    margin-bottom: 10px;
    width : 100%;
}

.pop-up-cancel:hover 
{
    color: white;
    background-color: #00468D;
}

.pop-up-password-container
{
    display: flex;
    flex-direction: column;
    margin: 0px 10%;
    align-items: center;
    justify-content: center;
}

.pop-up-forgot-password
{
    margin-top : 20px;
    margin-bottom : 80px;
    color: white;
    transition: 300ms ease;
    cursor: pointer;
    text-decoration: underline;
}

.pop-up-forgot-password:hover
{
    color:#ecaa1e;
}

.password-form-container
{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top : 100px;
}

.password-form
{
    background-color:#00468D;
    border-radius: 12px;
    padding : 20px;
    width : 800px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;  
    color: white;
}

.password-form-title
{
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    margin-bottom : 40px;
}

.password-form-subtitle
{
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    margin-bottom : 40px;
}

.password-form-txt
{
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    margin-bottom : 20px;
}

.password-form-input
{
    width : 50%;
    padding : 5px 10px;
    margin-bottom : 50px;
    color: #001E60;
}

.password-form-button
{
    font-weight: 600;
    background-color: #ecaa1e;
    color: #001E60;
    padding : 8px 20px;
    width : 50%;
    margin-bottom: 50px;
    border-radius: 20px;
    margin-top: 20px;
    transition: 300ms ease;

}

.password-form-button:hover
{
    color: white;
    background-color:#001E60;
}


.password-form-submit
{
    font-weight: 600;
    background-color: #ecaa1e;
    color: #001E60;
    padding : 8px 20px;
    width : 50%;
    margin-bottom: 50px;
    margin-top: 20px;
    border-radius: 20px;
    transition: 300ms ease;
}

.password-form-submit:hover
{
    color: white;
    background-color:#001E60;
}

#profile-icon-thumbnail
{
    width : 250px;
    height : 250px;
}

#profile-cancel-button
{
    margin-top: 40px;
}


@media all and (max-width : 1200px)
{
    .profile-picture
    {
        margin-right: 40px;
        width : 200px;
    }

    .profile-input-container
    {
        width : 70%;
    }

}

@media all and (max-width : 850px)
{
    .profile-inputs-section
    {
        flex-direction: column;
    }

    .profile-input-name
    {
        justify-content: center;
    }

    .profile-input-email
    {
        justify-content: center;
    }

    .profile-name
    {
        width: 100%;
    }

    .profile-email
    {
        width: 100%;
    }

    .profile-img
    {
        width : 70%;
    }

    .profile-container
    {
        flex-direction: column;
        padding-top: 110px;
    }

    .profile-details
    {
        margin-left: 30px;
    }

    .profile-picture
    {
        margin-right: 0px;
        margin-bottom: 50px;
        flex-direction: row;
    }

    .profile-input-container
    {
        width: 90%;
    }

    .profile-save-button
    {
        width: 90%;
    }

    .password-popup-content
    {
        width : 80%;
        margin-top: 180px;
        padding: 20px;
    }

    .password-form
    {
        width : 80%;
    }

    .password-form-input
    {
        width : 70%;
    }

    .password-form-submit
    {
        width : 70%;
    }

    .password-form-button
    {
        width: 70%;
    }

    .profile-picture-editor
    {
        padding-top : 0px;
    }

    .profile-image-edit-button
    {
        scale: 1.0;
        bottom: 40px;
        left: 10px;
    }
}

@media all and (max-width : 600px)
{

    .profile-picture
    {
        margin-bottom: 20px;
    }

    .profile-img
    {
        width : 70%;
    }

    .password-popup-content
    {
        width : 90%;
    }

    .password-form
    {
        width : 85%;
    }

    .password-form-input
    {
        width : 80%;
    }

    .password-form-submit
    {
        width : 80%;
    }

    .password-form-button
    {
        width: 80%;
    }

    .password-form-subtitle
    {
        font-size: 14px;
    }

    .password-form-txt
    {
        font-size: 14px;
    }
}

@media all and (max-width : 480px)
{
    .profile-container
    {
        padding: 110px 10px 150px 10px;
    }

    .profile-picture
    {
        width : 200px;
    }

    .profile-details
    {
        font-size: 14px;
        margin-left: 15px;
    }

    .profile-input-name
    {
        flex-direction: column;
        font-size: 14px;
    }

    .profile-name-title
    {
        margin-right : 0px;
        margin-bottom : 10px;
    }

    .profile-input-email
    {
        flex-direction: column;
        font-size: 14px;
    }

    .profile-email-title
    {
        margin-right : 0px;
        margin-bottom : 10px;
    }

    .profile-description-container
    {
        font-size : 14px;
        align-items: center;
    }

    .profile-description
    {
        height: 200px;
    }

    .profile-change-container
    {
        justify-content: center;
        width : 100%;
    }

    .profile-section-container
    {
        margin-bottom: 30px;
        margin: 0px 10px;
    }

    .profile-section-title
    {
        font-size: 14px;
    }

    .profile-section-input
    {
        font-size: 14px;
    }

    .profile-img 
    {
        width: 60%;
    }

    .profile-analytics
    {
        margin-top: 40px;
    }

    .profile-save-button
    {
        margin-top : 60px;
        font-size : 16px;
        padding: 12px 10px;
    }

    .password-popup-content
    {
        margin-top : 140px;
    }

    .pop-up-password-container
    {
        margin: 0px 5%;
    }

    .pop-up-enter
    {
        font-size: 14px;
    }

    .pop-up-cancel
    {
        font-size: 14px;
    }

    .pop-up-forgot-password
    {
        font-size: 14px;
    }

    .pop-up-old-password
    {
        font-size: 14px;
        width : 100%;
    }

    .password-form
    {
        width : 90%;
    }

    .password-form-input
    {
        width : 90%;
        font-size : 12px;
    }

    .password-form-submit
    {
        width: 90%;
        font-size : 14px;
    }

    .password-form-button
    {
        width: 90%;
        font-size : 14px;
    }

    .password-form-title
    {
        font-size: 20px;
    }

    .profile-image-edit-button
    {
        scale: 0.9;
        bottom: 35px;
        left: 25px;
    }
}

@media all and (max-width : 360px)
{
    .profile-picture
    {
        flex-direction: column;
        margin-bottom: 30px;
    }

    .profile-details
    {
        margin-left: 0px;
    }

    .profile-img
    {
        width: 70%;
    }

    .profile-image-edit-button
    {
        scale: 1;
        top: 85px;
        left: 140px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/account/profile.css"],"names":[],"mappings":"AAGA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;;AAGA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;AAEF;;IAEI,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;;IAElB,eAAe;IACf,eAAe;IACf,cAAc;;IAEd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,wBAAwB;IACxB,0BAA0B;IAC1B,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,gCAAgC;AACpC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;;IAEI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;IAEI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,UAAU;IACV,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mCAAmC;AACvC;;AAEA;;IAEI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,UAAU;IACV,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;;AAE1B;;AAEA;;IAEI,YAAY;IACZ,wBAAwB;AAC5B;;;AAGA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;IACb,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;AACpB;;;AAGA;;IAEI;;QAEI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;;QAEI,WAAW;IACf;;AAEJ;;AAEA;;IAEI;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,WAAW;QACX,iBAAiB;QACjB,aAAa;IACjB;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,UAAU;QACV,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;;;IAGI;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;;QAEI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;;QAEI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;;QAEI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;;QAEI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,uBAAuB;QACvB,YAAY;IAChB;;IAEA;;QAEI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,YAAY;IAChB;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;QACX,gBAAgB;IACpB;;IAEA;;QAEI,UAAU;QACV,gBAAgB;IACpB;;IAEA;;QAEI,UAAU;QACV,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,UAAU;QACV,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;;IAEI;;QAEI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,QAAQ;QACR,SAAS;QACT,WAAW;IACf;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Poppins:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i\");\n\n\n.zoom-slider {\n    padding-top: 20px;\n    padding-bottom: 20px;\n}\n\n.save-profile-image-button {\n    width: 70%;\n    background-color: #001E60;\n    color: white;\n    padding: 8px 30px;\n    margin-top: 10px;\n    margin-bottom: 30px;\n    border: none;\n    border-radius: 10px;\n    font-size: 20px;\n    font-weight: 600;\n    cursor: pointer;\n    letter-spacing: 2px;\n    transition: 300ms ease;\n    text-align: center; \n}\n\n.save-profile-image-button:hover\n{\n    background-color: #ecaa1e;\n    color:#001E60;\n}\n\n.picture-upload {\n    padding: 20px;\n    padding-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n\n.profile-page\n{\n    overflow-x: hidden;\n}\n\n.file-upload-button {\n    padding: 8px 20px;\n    margin: 10px;\n    border: none;\n    outline: none;\n    background-color: #3498db;\n    color: #fff;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: 200ms ease;\n  }\n  \n  .file-upload-button:hover {\n    background-color: #2980b9;\n  }\n  \n  .file-upload-button:active {\n    background-color: #1c638d;\n  }\n  \n  .profile-picture-editor {\n    padding-top: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n.profile-container\n{\n    padding: 40px 20px 164px 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.profile-picture\n{\n    width : 225px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    color : white;\n    position: relative;\n    margin-right: 80px;\n}\n\n.profile-img\n{\n    width : 100%;\n    margin-bottom : 20px;\n    border-radius: 50%;\n}\n\n.profile-image-edit-button {\n    position: absolute;\n    bottom: 120px;\n    right: 20px;\n    background-color: #fff; \n    border: 1px solid #ccc; \n    border-radius: 50%; \n\n    cursor: pointer;\n    font-size: 28px;\n    color: #001E60;\n\n    width: 38px;\n    height: 38px; \n    display: flex;\n    justify-content: center; \n    align-items: center; \n    scale: 1.1;\n}\n\n.profile-name-display\n{\n    margin-bottom : 5px;\n    white-space: nowrap;\n}\n\n.profile-email-display\n{\n    margin-bottom : 8px;\n}\n\n.profile-inputs-section\n{\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.profile-change-container\n{\n    display: flex;\n    width: 89%;\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: 35px;\n}\n\n.profile-change\n{\n    font-size: 15px;\n    background-color:#001E60;\n    padding: 6px 16px 6px 16px;\n    margin: 0px 10px;\n    font-family: \"poppins\";\n    color: white;\n    border-radius: 15px;\n    font-weight: 500;\n    text-decoration: none;\n    cursor: pointer;\n    border: none;\n    transition: all 0.3s ease-in-out;\n}\n\n.profile-change:hover\n{\n    background-color :#00468D;\n}\n\n.profile-input-container\n{\n    width : 60%;\n    display: flex;\n    justify-content: center;\n    flex-wrap : wrap;\n    justify-content: flex-end;\n}\n\n.profile-input-name\n{\n    width : 100%;\n    display: flex;\n    color: white;\n    margin-bottom : 40px;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.profile-input-email\n{\n    width : 100%;\n    display: flex;\n    color: white;\n    margin-bottom : 40px;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.profile-name-title\n{\n    margin-right : 10px;\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n.profile-email-title\n{\n    margin-right : 10px;\n    font-weight: 500;\n}\n\n.profile-name\n{\n    width : 70%;\n    padding : 8px 10px;\n    color : white;\n    border-radius : 10px;\n    background-color :#00468D;\n}\n\n.profile-email\n{\n    width: 70%;\n    padding : 8px 10px;\n    color : white;\n    border-radius : 10px;\n    background-color :#00468D;\n}\n\n.profile-description-container\n{\n    width : 100%;\n    display: flex;\n    flex-direction: column;\n    color: white;\n}\n\n.profile-description-title\n{\n    margin-bottom : 10px;\n    font-weight: 500;\n}\n\n.profile-description\n{\n    width : 100%;\n    padding : 12px 15px;\n    color : white;\n    border-radius : 10px;\n    background-color :#00468D;\n}\n\n.profile-analytics\n{\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: space-around;\n    color : white;\n    margin-top : 70px;\n}\n\n.profile-section-container\n{\n    text-align: center;\n    margin: 0px 20px;\n}\n\n.profile-section-title\n{\n    font-weight: 500;\n    font-size : 18px;\n    margin-bottom : 5px;\n}\n\n.profile-section-input\n{\n    font-size : 18px;\n}\n\n.profile-save-button\n{\n    width: 80%;\n    background-color: #001E60;\n    color: white;\n    padding: 14px 20px;\n    margin-top: 100px;\n    border: none;\n    border-radius: 4px;\n    font-size: 20px;\n    font-weight: 600;\n    cursor: pointer;\n    letter-spacing: 2px;\n    transition: 500ms ease;\n    text-align: center;\n}\n\n.profile-save-button:hover\n{\n    background-color : #ecaa1e;\n    color: #001E60;\n}\n\n.password-popup-container\n{\n    position: fixed;\n    top: -50px;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    animation: fade-in 0.2s ease-in-out;\n}\n\n.password-popup-content\n{\n    background-color: #0096C9;\n    padding: 30px;\n    border-radius: 10px;\n    z-index: 1;\n    width: 50%;\n    padding-bottom: 35px;\n    margin-top : 60px;\n}\n\n.pop-up-old-password\n{\n    margin-top : 30px;\n    padding : 8px 12px;\n    width: 300px;\n}\n\n.pop-up-enter\n{\n    font-size : 20px;\n    background-color:#001e60;\n    padding: 6px 16px;\n    font-family: \"poppins\";\n    color: white;\n    font-weight: bold;\n    border-radius: 15px;\n    text-decoration: none;\n    transition: all 0.3s ease-in-out;\n    margin-bottom: 20px;\n    width : 100%;\n}\n\n.pop-up-enter:hover\n{\n    color: white;\n    background-color: #00468D;\n}\n\n.pop-up-cancel\n{\n    font-size : 20px;\n    background-color: #ecaa1e;\n    padding: 6px 16px;\n    font-family: \"poppins\";\n    color: #001E60;\n    font-weight: bold;\n    border-radius: 15px;\n    text-decoration: none;\n    transition: all 0.3s ease-in-out;\n    margin-bottom: 10px;\n    width : 100%;\n}\n\n.pop-up-cancel:hover \n{\n    color: white;\n    background-color: #00468D;\n}\n\n.pop-up-password-container\n{\n    display: flex;\n    flex-direction: column;\n    margin: 0px 10%;\n    align-items: center;\n    justify-content: center;\n}\n\n.pop-up-forgot-password\n{\n    margin-top : 20px;\n    margin-bottom : 80px;\n    color: white;\n    transition: 300ms ease;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n.pop-up-forgot-password:hover\n{\n    color:#ecaa1e;\n}\n\n.password-form-container\n{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top : 100px;\n}\n\n.password-form\n{\n    background-color:#00468D;\n    border-radius: 12px;\n    padding : 20px;\n    width : 800px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;  \n    color: white;\n}\n\n.password-form-title\n{\n    text-align: center;\n    font-size: 24px;\n    font-weight: 500;\n    margin-bottom : 40px;\n}\n\n.password-form-subtitle\n{\n    text-align: center;\n    font-size: 18px;\n    font-weight: 400;\n    margin-bottom : 40px;\n}\n\n.password-form-txt\n{\n    text-align: center;\n    font-size: 18px;\n    font-weight: 400;\n    margin-bottom : 20px;\n}\n\n.password-form-input\n{\n    width : 50%;\n    padding : 5px 10px;\n    margin-bottom : 50px;\n    color: #001E60;\n}\n\n.password-form-button\n{\n    font-weight: 600;\n    background-color: #ecaa1e;\n    color: #001E60;\n    padding : 8px 20px;\n    width : 50%;\n    margin-bottom: 50px;\n    border-radius: 20px;\n    margin-top: 20px;\n    transition: 300ms ease;\n\n}\n\n.password-form-button:hover\n{\n    color: white;\n    background-color:#001E60;\n}\n\n\n.password-form-submit\n{\n    font-weight: 600;\n    background-color: #ecaa1e;\n    color: #001E60;\n    padding : 8px 20px;\n    width : 50%;\n    margin-bottom: 50px;\n    margin-top: 20px;\n    border-radius: 20px;\n    transition: 300ms ease;\n}\n\n.password-form-submit:hover\n{\n    color: white;\n    background-color:#001E60;\n}\n\n#profile-icon-thumbnail\n{\n    width : 250px;\n    height : 250px;\n}\n\n#profile-cancel-button\n{\n    margin-top: 40px;\n}\n\n\n@media all and (max-width : 1200px)\n{\n    .profile-picture\n    {\n        margin-right: 40px;\n        width : 200px;\n    }\n\n    .profile-input-container\n    {\n        width : 70%;\n    }\n\n}\n\n@media all and (max-width : 850px)\n{\n    .profile-inputs-section\n    {\n        flex-direction: column;\n    }\n\n    .profile-input-name\n    {\n        justify-content: center;\n    }\n\n    .profile-input-email\n    {\n        justify-content: center;\n    }\n\n    .profile-name\n    {\n        width: 100%;\n    }\n\n    .profile-email\n    {\n        width: 100%;\n    }\n\n    .profile-img\n    {\n        width : 70%;\n    }\n\n    .profile-container\n    {\n        flex-direction: column;\n        padding-top: 110px;\n    }\n\n    .profile-details\n    {\n        margin-left: 30px;\n    }\n\n    .profile-picture\n    {\n        margin-right: 0px;\n        margin-bottom: 50px;\n        flex-direction: row;\n    }\n\n    .profile-input-container\n    {\n        width: 90%;\n    }\n\n    .profile-save-button\n    {\n        width: 90%;\n    }\n\n    .password-popup-content\n    {\n        width : 80%;\n        margin-top: 180px;\n        padding: 20px;\n    }\n\n    .password-form\n    {\n        width : 80%;\n    }\n\n    .password-form-input\n    {\n        width : 70%;\n    }\n\n    .password-form-submit\n    {\n        width : 70%;\n    }\n\n    .password-form-button\n    {\n        width: 70%;\n    }\n\n    .profile-picture-editor\n    {\n        padding-top : 0px;\n    }\n\n    .profile-image-edit-button\n    {\n        scale: 1.0;\n        bottom: 40px;\n        left: 10px;\n    }\n}\n\n@media all and (max-width : 600px)\n{\n\n    .profile-picture\n    {\n        margin-bottom: 20px;\n    }\n\n    .profile-img\n    {\n        width : 70%;\n    }\n\n    .password-popup-content\n    {\n        width : 90%;\n    }\n\n    .password-form\n    {\n        width : 85%;\n    }\n\n    .password-form-input\n    {\n        width : 80%;\n    }\n\n    .password-form-submit\n    {\n        width : 80%;\n    }\n\n    .password-form-button\n    {\n        width: 80%;\n    }\n\n    .password-form-subtitle\n    {\n        font-size: 14px;\n    }\n\n    .password-form-txt\n    {\n        font-size: 14px;\n    }\n}\n\n@media all and (max-width : 480px)\n{\n    .profile-container\n    {\n        padding: 110px 10px 150px 10px;\n    }\n\n    .profile-picture\n    {\n        width : 200px;\n    }\n\n    .profile-details\n    {\n        font-size: 14px;\n        margin-left: 15px;\n    }\n\n    .profile-input-name\n    {\n        flex-direction: column;\n        font-size: 14px;\n    }\n\n    .profile-name-title\n    {\n        margin-right : 0px;\n        margin-bottom : 10px;\n    }\n\n    .profile-input-email\n    {\n        flex-direction: column;\n        font-size: 14px;\n    }\n\n    .profile-email-title\n    {\n        margin-right : 0px;\n        margin-bottom : 10px;\n    }\n\n    .profile-description-container\n    {\n        font-size : 14px;\n        align-items: center;\n    }\n\n    .profile-description\n    {\n        height: 200px;\n    }\n\n    .profile-change-container\n    {\n        justify-content: center;\n        width : 100%;\n    }\n\n    .profile-section-container\n    {\n        margin-bottom: 30px;\n        margin: 0px 10px;\n    }\n\n    .profile-section-title\n    {\n        font-size: 14px;\n    }\n\n    .profile-section-input\n    {\n        font-size: 14px;\n    }\n\n    .profile-img \n    {\n        width: 60%;\n    }\n\n    .profile-analytics\n    {\n        margin-top: 40px;\n    }\n\n    .profile-save-button\n    {\n        margin-top : 60px;\n        font-size : 16px;\n        padding: 12px 10px;\n    }\n\n    .password-popup-content\n    {\n        margin-top : 140px;\n    }\n\n    .pop-up-password-container\n    {\n        margin: 0px 5%;\n    }\n\n    .pop-up-enter\n    {\n        font-size: 14px;\n    }\n\n    .pop-up-cancel\n    {\n        font-size: 14px;\n    }\n\n    .pop-up-forgot-password\n    {\n        font-size: 14px;\n    }\n\n    .pop-up-old-password\n    {\n        font-size: 14px;\n        width : 100%;\n    }\n\n    .password-form\n    {\n        width : 90%;\n    }\n\n    .password-form-input\n    {\n        width : 90%;\n        font-size : 12px;\n    }\n\n    .password-form-submit\n    {\n        width: 90%;\n        font-size : 14px;\n    }\n\n    .password-form-button\n    {\n        width: 90%;\n        font-size : 14px;\n    }\n\n    .password-form-title\n    {\n        font-size: 20px;\n    }\n\n    .profile-image-edit-button\n    {\n        scale: 0.9;\n        bottom: 35px;\n        left: 25px;\n    }\n}\n\n@media all and (max-width : 360px)\n{\n    .profile-picture\n    {\n        flex-direction: column;\n        margin-bottom: 30px;\n    }\n\n    .profile-details\n    {\n        margin-left: 0px;\n    }\n\n    .profile-img\n    {\n        width: 70%;\n    }\n\n    .profile-image-edit-button\n    {\n        scale: 1;\n        top: 85px;\n        left: 140px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
